var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 896,
    viewBox: "0 0 704 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M694.6 224.7L479.4 9.4C473.4 3.4 465.2 0 456.7 0H32C14.3 0 0 14.3 0 32V864C0 881.7 14.3 896 32 896H672C689.7 896 704 881.7 704 864V247.3C704 238.8 700.6 230.7 694.6 224.7ZM240 338C262.1 338 280 355.9 280 378C280 400.1 262.1 418 240 418C217.9 418 200 400.1 200 378C200 355.9 217.9 338 240 338ZM536 632H168C161.3 632 157.6 624.3 161.7 619.1L261.5 491.9C262.248 490.944 263.204 490.171 264.296 489.639C265.388 489.107 266.586 488.831 267.8 488.831C269.014 488.831 270.212 489.107 271.304 489.639C272.396 490.171 273.352 490.944 274.1 491.9L315.2 544.3L393 445.1C393.748 444.144 394.704 443.371 395.796 442.839C396.888 442.307 398.086 442.031 399.3 442.031C400.514 442.031 401.712 442.307 402.804 442.839C403.896 443.371 404.852 444.144 405.6 445.1L542.1 619.1C546.4 624.3 542.6 632 536 632V632ZM442 262V73.8L630.2 262H442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.0dcbe82b66fd4c4294a4052c35538c9c.svg";
export { ForwardRef as ReactComponent };